import { gql } from "@apollo/client";

export const acceptOffer = gql`
  mutation AcceptOffer($input: AcceptOffer!) {
    acceptOffer(input: $input)
  }
`;

export const sendOfferParticipationMessage = gql`
  mutation SendOfferParticipationMessage(
    $input: SendOfferParticipationMessage!
  ) {
    sendOfferParticipationMessage(input: $input)
  }
`;

export const withdrawOfferParticipation = gql`
  mutation WithdrawOfferParticipation($input: WithdrawOfferParticipation!) {
    withdrawOfferParticipation(input: $input)
  }
`;

export const updateOfferParticipationPercentage = gql`
  mutation UpdateOfferParticipationPercentage(
    $input: UpdateOfferParticipationPercentage!
  ) {
    updateOfferParticipationPercentage(input: $input)
  }
`;

export const readTransactionThread = gql`
  mutation ReadTransactionThread($input: [ID]!, $published_by: String!) {
    readTransactionThread(input: $input, published_by: $published_by) 
  }
`;

export const updateTermsOfService = gql`
  mutation UpdateTermsOfService($args: TermsOfServiceInput!) {
    updateTermsOfService(args: $args)
  }
`;
